// Separator Comment
// -----------------------------

// Tab Management Functionality
var TabManager = (function() {
    function openTab(evt, tabName) {
        var i, tabcontent, tablinks;

        tabcontent = document.getElementsByClassName("tabcontent");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none"; 
        }

        tablinks = document.getElementsByClassName("tablinks");
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(/\bactive\b/, '');
        }

        // Add !important for display: block
        document.getElementById(tabName).style.setProperty('display', 'block', 'important');
        evt.currentTarget.className += " active";
    }

    return {
        openTab: openTab
    };
})();


